import React, { FunctionComponent, useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import Model, { IEmailOptions } from '../../model/ShopKeeper.model';
import Form from '../../../form/Form';
import toastr from '../../../toastr';

interface IProps {
  container: Object;
  hide: Function;
  show: boolean;
  model: Model;
}

const EmailOptionsModal: FunctionComponent<IProps> = ({ container, hide, model, show }) => {
  // Hack to reset blaze-form with default layout values on reset action
  const [refreshing, setRefreshing] = useState(false);
  useEffect(() => {
    // Allow 1 redraw, then re-render blaze-form
    if (refreshing) {
      setRefreshing(false);
    }
  }, [refreshing]);

  const { invoiceEmails, quoteEmails, skipEmails } = model.getEmailOptions();

  const layout = [
    {
      type: 'tab',
      label: 'Set Email Recipients',
      fields: [
        {
          col: 6,
          name: 'invoiceEmails',
          label: 'Parts Invoices',
          type: 'email',
          maxLen: '60',
          collection: true,
          control: 'Tags',
          data: invoiceEmails,
        },
        {
          col: 6,
          name: 'quoteEmails',
          label: 'Parts Quotes',
          type: 'email',
          maxLen: '60',
          collection: true,
          control: 'Tags',
          data: quoteEmails,
        },
        {
          col: 12,
          name: 'skipEmails',
          label: 'Do Not Send Any Emails',
          type: 'string',
          control: 'Checkbox',
          data: skipEmails,
        },
      ],
    },
  ];

  const customActions = [
    {
      label: 'Reset',
      action: () => {
        model.clearEmailOverrides();
        setRefreshing(true);
      },
      style: 'warning',
      title: 'Reset to Customer File Settings',
    },
  ];

  const handleSubmit = (options: IEmailOptions) => {
    // Timeout lets BlazeForm unmount gracefully
    setTimeout(() => {
      hide();
      model.setEmailOptions(options);
      toastr.success('Success', 'Email Options Updated');
    }, 0);
  };

  return (
    <Modal
      backdrop="static"
      container={container as any}
      dialogClassName="sk-emailOptionsModal"
      onHide={hide as any}
      show={show}
      size="lg"
    >
      <Modal.Header closeButton={true}>
        <Modal.Title>Email Options</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!refreshing ? (
          <Form
            customActions={customActions}
            exportFormat="object"
            layout={layout}
            onCancel={hide as any}
            submit={handleSubmit}
            submitLabel="Update"
            submitAll
          />
        ) : null}
      </Modal.Body>
    </Modal>
  );
};

export default EmailOptionsModal;
